import { Map, Record } from 'immutable';

export enum EntityStatus {
  None = 'None',
  Requested = 'Requested',
  Loaded = 'Loaded',
  Fetching = 'Fetching',
}

export class EntityMeta extends Record({
  status: EntityStatus.None,
  dateLoaded: null as Date | null,
  dateFetched: null as Date | null,
}) {
  public status: EntityStatus;
  public dateLoaded: Date | null;
  public dateFetched: Date | null;

  public markAsLoaded() {
    return this.withMutations((s) => {
      s.status = EntityStatus.Loaded;
      s.dateLoaded = new Date();
    });
  }

  public markAsFetching() {
    return this.withMutations((s) => {
      s.status = EntityStatus.Fetching;
      s.dateFetched = new Date();
    });
  }

  public markAsRequested() {
    return this.withMutations((s) => {
      s.status = EntityStatus.Requested;
      s.dateFetched = new Date();
    });
  }
}

export class EntityStore<TEntity extends { id: string; dateLastUpdated: Date }> extends Record({
  entities: Map<string, any>(),
  meta: Map<string, EntityMeta>(),
}) {
  public entities: Map<string, TEntity>;
  public meta: Map<string, EntityMeta>;
}
